import React, { lazy } from 'react';
interface EbookMockupProps {
  title?: string;
  subtitle?: string;
  className?: string;
  imageSrc?: string;
}
export function EbookMockup({
  title = '40 RECETAS KETO',
  subtitle = 'EN AIR FRYER',
  className = '',
  imageSrc
}: EbookMockupProps) {
  if (imageSrc) {
    return <div className={`mx-auto ${className}`} data-id="element-62">
        <img loading="lazy" src={imageSrc} alt={`${title} ${subtitle}`} className="w-full h-full object-cover rounded-xl shadow-[12px_12px_30px_rgb(0,168,107,0.2)]" data-id="element-63" />
      </div>;
  }
  return;
}